import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./couponCode.gql";
import { useSelector } from "react-redux";

export const useCouponCode = (props) => {
  const [couponCode, setCouponCode] = useState("");
  const [couponCodeError, setCouponCodeError] = useState("");

  const { getAppliedCouponsQuery, applyCouponMutation, removeCouponMutation } =
    DEFAULT_OPERATIONS;
  const { setIsCartUpdating } = props;

  const { cartId } = useSelector((state) => state.cartSlice);

  const { data, error: fetchError } = useQuery(getAppliedCouponsQuery, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    skip: !cartId,
    variables: {
      cartId,
    },
  });

  const isValidCouponCode = () => {
    if (couponCode.trim() === "") {
      setCouponCodeError("Enter the coupon code");
      return false;
    } else {
      setCouponCodeError("");
      return true;
    }
  };

  const [
    applyCoupon,
    { called: applyCouponCalled, error: applyError, loading: applyingCoupon },
  ] = useMutation(applyCouponMutation);

  const [
    removeCoupon,
    {
      called: removeCouponCalled,
      error: removeCouponError,
      loading: removingCoupon,
    },
  ] = useMutation(removeCouponMutation);

  const validate = () => {
    if (isValidCouponCode()) {
      return true;
    } else {
      isValidCouponCode();
    }
    return false;
  };

  const handleApplyCoupon = async (event) => {
    event.preventDefault();
    if (!validate()) {
      return;
    }
    try {
      await applyCoupon({
        variables: {
          cartId,
          couponCode,
        },
      });
    } catch (e) {}
  };

  const handleRemoveCoupon = async (event, couponCode) => {
    event.preventDefault();
    try {
      await removeCoupon({
        variables: {
          cartId,
          couponCode,
        },
      });
      setCouponCode("");
    } catch (e) {}
  };

  useEffect(() => {
    if (applyCouponCalled || removeCouponCalled) {
      setIsCartUpdating(applyingCoupon || removingCoupon);
    }
  }, [
    applyCouponCalled,
    applyingCoupon,
    removeCouponCalled,
    removingCoupon,
    setIsCartUpdating,
  ]);

  return {
    applyingCoupon,
    data,
    handleApplyCoupon,
    handleRemoveCoupon,
    removingCoupon,
    setCouponCode,
    couponCode,
    fetchError,
    applyError,
    removeCouponError,
    isValidCouponCode,
    couponCodeError,
  };
};
